export default __webpack_public_path__ + "static/media/a5.0fc43285.png";